import React from 'react';
import { useState} from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';


 


function InformationCoach(props) {

  const [error, setError] = useState(null);
  const [changement,setChangement] = useState(false)
  const [numeroGSM,setNumeroGSM] = useState('')
  const [isLoading,setIsLoading] = useState(false)
  const [success,setSucces] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setChangement(false);
    setError(null);
    setSucces(false)

    try {
      await axios.patch(`${apiUrl}/parametre/modification/coach`, {
        id: props.userData.user.donnée.results[0].id,
        numeroGSM : numeroGSM
      },{
        withCredentials: true
      });

      setError(null);
      setNumeroGSM('')
      setIsLoading(false);
      setSucces(true)
      setTimeout(() => {
        window.location.reload();
      }, 5000);

    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(true);
      }
    }
  };







        
  return (
  <>
      {isLoading && (
    <>
      <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
      </div>
    </>

  )}
    {changement && (
        <Modal show={changement} onHide={() => setChangement(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Modification de vos données personnelles</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Êtes-vous sûr de modifier vos données personnelles ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setChangement(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => {handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
              Modifier vos informations
            </Button>
          </Modal.Footer>
        </Modal>
      )}
  {props.userData ? (
    <> 
        <h2 style={{textAlign:"center"}}>Informations personnelles</h2>
        {error && (
                <Alert key="danger" variant="danger" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                    Erreur ! {error}. 
                </Alert>
                )}
                {success && (
                        <Alert key="success" variant="success" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                        Félicitations ! Vos informations ont été modifées avec succès.
                      </Alert>
              )}
          <div className="card-body">
            <div className="ajout2">
                <form className="Invite_Joueur" onSubmit={(e) => { e.preventDefault(); setChangement(true); }}> 
                    <div>
                        <label htmlFor="nom" className="label-1" >
                        <br />Nom<br />
                        <input
                            name="nom"
                            type="text"
                            id="nom"
                            value={" "+ props.userData.user.donnée.results[0].nom_coach}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="prenom" className="label-1" >
                        <br />Prénom<br />
                        <input
                            name="prenom"
                            type="text"
                            id="prenom"
                            value={" "+ props.userData.user.donnée.results[0].prenom}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="email" className="label-1" >
                        <br />Email<br />
                        <input
                            name="email"
                            type="mail"
                            id="email"
                            value={" "+ props.userData.user.donnée.results[0].email}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="date_" className="label-1" >
                        <br />Date de naissance<br />
                        <input
                            name="date_"
                            type="date"
                            id="date_"
                            value={props.userData.user.donnée.results[0].naissance}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="telephone_" className="label-1" >
                        <br />Numéro de téléphone actuel<br />
                        <input
                            name="telephone_"
                            type="tel"
                            id="telephone_"
                            value={" " + props.userData.user.donnée.results[0].contact}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_phone" className="label-1" >
                        <br />Changer de numéro de téléphone<br />
                        <input
                            name="new_phone"
                            type="tel"
                            id="new_phone"
                            placeholder='0490-508-401'
                            value={numeroGSM} onChange={(e) => {setNumeroGSM(e.target.value)}}
                        />
                        </label>
                        
                    </div>
                    <br/>
                    <button type="submit" className="conect" style={{margin: "auto"}}>
                            Modifier vos informations personnelles
                        </button>
                </form>
                <br/>
            
            
            </div>
      
        </div>
 
      </>
      ) :(
        <>
        <Navigation/>        
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default InformationCoach;
